import React from "react";
import styled from "styled-components";

const StyledSelect = styled.select`
  background-color: #fff;
  border: none;
  height: 34px;
  margin-right: 5px;
  width: 170px;
`;

const CodeSelectBox = ({
  value,
  codes,
  onChange,
  isCodeVisible = false,
  width = "170px",
  style = {},
  disabled = false,
}) => {
  return (
    <StyledSelect
      value={value}
      onChange={onChange}
      width={{ width }}
      style={{ width: width, ...style }}
      disabled={disabled}
    >
      {codes.map((code) => (
        <option key={code.code} value={code.code}>
          {code.codeDesc}
          {isCodeVisible ? ` (${code.code})` : ""}
        </option>
      ))}
    </StyledSelect>
  );
};

export default CodeSelectBox;
